<template>
  <div class="upload-area"
    style="border:areaBorder"
    :disabled="isDisabled"
    @dragover="dragoverFile"
    @dragleave="dragleaveFile"
    @drop="dropFile"
    >
    <template v-if="$device.isMobile">
      <template v-if="uiType == 'thumbnail'">
        <div class="upload-image">
          <div class="upload-image__buttons">
            <button class="upload-image__button upload-image__button--active" v-for="storedFile in storedFiles"
              :key="storedFile.id" @click="removeFile(storedFile.id)">
              <ComImage :src="storedFile.id" :alt="storedFile.name"/>
            </button>
            <div v-if="progress" style="display:flex;flex-direction:column;justify-content:center">
              <span style="text-align:center">{{ progress.status }}</span>
              <progress v-if="progress" style="width:100%;height:5px" :value="progress.bytes.current" :max="progress.bytes.total" />
            </div>
            <button v-if="isAddNewable" class="upload-image__button upload-image__button--empty" @click="() => inputFile?.click()"></button>
            <input class="upload-image__input" ref="input-file" type="file" @click="checkUploadtoken" @change="selectFile(inputFile?.files)" :multiple="uploadToken && uploadToken.filesLimit > 1"  :accept="uploadToken && uploadToken.acceptTypes.join(',')"/>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="upload-file">
          <button type="button" @click="() => progress ? abort() : inputFile?.click()" class="btn btn-outline md v2 upload-file-button"
            :class="[{ active: storedFiles.length > 0 }]">
            {{ progress ?  '전송취소' : '파일찾기' }}
          </button>
          <div class="upload-file__info">
            <p class="highlight">
              {{ uploadableDesc }}
            </p>
          </div>
        </div>
        <div class="upload-file__list" style="position:relative">
          <div v-if="progress" class="upload-progress-area">
            <span style="text-align:center">
              {{ progress.status }}
              <progress style="width:100%;height:5px" :value="progress.bytes.current" :max="progress.bytes.total" />
            </span>
          </div>            
          <ul v-if="storedFiles.length > 0">
            <li v-for="storedFile in storedFiles" :key="storedFile.id">
              <!-- <ComImage v-if="storedFile.contentType.startsWith('image/')" at="cdn" :src="storedFile.id" size="20"/>
              <i v-else class="ico-file" style="width:20px;height:20px"/> -->
              <span>{{ fileNameSimplify(storedFile.name) }}</span>
              <button class="delete-btn" @click="removeFile(storedFile.id)"></button>
            </li>
          </ul>
          <input v-if="isAddNewable" class="upload-file__input" ref="input-file" type="file" @click="checkUploadtoken" @change="selectFile(inputFile?.files)" :multiple="uploadToken && uploadToken.filesLimit > 1"  :accept="uploadToken && uploadToken.acceptTypes.join(',')"/>
        </div>
      </template>
    </template>
    <template v-else>
      <template v-if="uiType == 'thumbnail'">
        <div :class="`file-box ${additionalClassStr}`">
          <div class="file-thumbnail">
            <div class="file-list" v-if="storedFiles.length > 0">
              <ul class="mt20 file-list">
                <li v-for="(storedFile, index) in storedFiles" :key="storedFile.id">
                  {{ storedFile.name }}
                  <ComImage :src="storedFile.id" :alt="storedFile.name"/>
                  <button class="delete-btn" @click="() => removeFile(storedFile.id)"></button>
                </li>
              </ul>
            </div>
            <div v-if="progress" style="display:flex;flex-direction:column;justify-content:center;width:75px">
              <span style="text-align:center">
                {{ progress.status }}
                <progress v-if="progress" style="width:100%;height:5px" :value="progress.bytes.current" :max="progress.bytes.total" />
              </span>
            </div>
            <input class="upload-image__input" ref="input-file" type="file" @click="checkUploadtoken" @change="selectFile(inputFile?.files)" :multiple="uploadToken && uploadToken.filesLimit > 1"  :accept="uploadToken && uploadToken.acceptTypes.join(',')"/>
            <button  v-if="isAddNewable"
              type="button" 
              @click="() => inputFile?.click()"
              class="btn btn-outline md"
              :class="[{ active: storedFiles.length > 0 }]"
            >
              파일찾기
            </button>
          </div>
        </div>
      </template>
      <template v-else>
        <div :class="`file-box ${additionalClassStr}`">
          <div class="file-type">
            <input ref="input-file" type="file" @click="checkUploadtoken" @change="selectFile(inputFile?.files)" :multiple="uploadToken && uploadToken.filesLimit > 1"  :accept="uploadToken && uploadToken.acceptTypes.join(',')"/>
            <button v-if="isAddNewable"
              type="button" 
              @click="() => progress ? abort() : inputFile?.click()"
              class="btn btn-outline md v1"
              :class="[{ active: storedFiles.length > 0 }]"
            >
              {{ progress ?  '전송취소' : '파일찾기' }}
            </button>
            <div class="file-info">{{ uploadableDesc }}</div>
          </div>
          <div class="file-list mt10" style="position:relative">
            <div v-if="progress" class="upload-progress-area">
              <span style="text-align:center">
                {{ progress.status }}
                <progress style="width:100%;height:5px" :value="progress.bytes.current" :max="progress.bytes.total" />
              </span>
            </div>            
            <ul v-if="storedFiles.length > 0">
              <li v-for="(storedFile, index) in storedFiles" :key="storedFile.id">
                <!-- <ComImage v-if="storedFile.contentType?.startsWith('image/')" at="cdn" :src="storedFile.id" size="20"/>
                <i v-else class="ico-file" style="width:20px;height:20px"/> -->
                {{ fileNameSimplify(storedFile.name) }}
                <button class="delete-btn" @click="removeFile(storedFile.id)"></button>
              </li>
            </ul>
          </div>
        </div>
      </template>
    </template>
  </div>
</template>

<script lang="ts">
import ComImage from "~/components/com/HconComImage.vue";
import { usePopup } from "@/composables/hconUsePopup";
import { COMMON_CODE } from "@/constants/hconMessageConstants";

interface FileUploadProps {
  tokenProvider: string;
  uiType?: 'default' | 'thumbnail';
  uploadableDesc?: string;
  disabled?: boolean | 'true' | 'false';
  selectValidator?: (selectedFiles:File[]) => string | null | undefined;
  uploaded?: CommonFile[];
  additionalClass?: string;
  filesLimit?: string | number;
  fileNameSimplify?: string | number;
}

interface UploadFileInfo {
  name: string;
  type: string;
  size: number;
}

interface UploadProgress {
  status: string;
  bytes: {
    total: number;
    current: number;
  },
  total: {
    size: string;
    cur: string;
    per: string;
  };
  files: {
    size: string;
    cur: string;
    per: string;
  }[];
}

</script>

<script lang="ts" setup>
  const { showAlert }               = usePopup()
  const props                       = withDefaults(defineProps<FileUploadProps>(), {autoUpload: true, disabled: false, fileNameSimplify: 10});
  const isDisabled                  = computed(() => props.disabled == true || props.disabled == 'true');
  const areaBorder                  = ref<string>();
  const inputFile                   = useTemplateRef('input-file');
  const uploadedFiles               = defineModel<CommonFile[]>({default: () => []});
  const storedFiles                 = computed(() => uploadedFiles.value.filter(uf => uf.status == 'STORED'));
  // const dialog                      = useHconDialog();
  const config                      = useHconConfig();
  const progress                    = ref<UploadProgress>();
  const sizeFormater                = new Intl.NumberFormat('ko-KR', {maximumFractionDigits:2, minimumFractionDigits:2});
  const perFormater                 = new Intl.NumberFormat('ko-KR', {style: 'percent', maximumFractionDigits:0, minimumFractionDigits:0});
  const uploadToken                 = ref<CommonFileUploadToken>();
  const fetchBuilder                = useHconFetchBuilder();
  const emits                       = defineEmits(['change', 'busy']);
  const isAddNewable                = ref(true);
  const curXhr:Ref<XMLHttpRequest|null>  = ref(null);
  const fetchWhoami                 = fetchBuilder.get<any>('/mypage/api/v1/private/auth/whoami').build();
  const fetchUploadToken            = fetchBuilder
                                      .get<CommonFileUploadToken>(props.tokenProvider)
                                      .transform<AjaxResult<any>>(res => res.data)
                                      .build();
  const additionalClassStr          = props.additionalClass ?? '';
  let   filesLimit                  = cu.toNumber(props.filesLimit) ?? -1;
  const displatFileNameLimitLength  = typeof(props.fileNameSimplify) == 'string' ? parseInt(props.fileNameSimplify) : props.fileNameSimplify;
  const fileNameSimplify            = (fileName:string) => {
    const sp    = fileName.lastIndexOf('.');
    let   fname = '';
    let   fext  = '';
    if (sp == -1) {
      fname = fileName;
    } else {
      fname = fileName.substring(0, sp);
      fext  = fileName.substring(sp+1);
    }
    if (fname.length > displatFileNameLimitLength) {
      fname = fname.substring(0, displatFileNameLimitLength) + '...';
    }
    return fname + fext;
  }

  watchEffect(() => {
    if (uploadToken.value !== undefined) {
      filesLimit  = uploadToken.value.filesLimit;
    }
    isAddNewable.value  = filesLimit == -1 || storedFiles.value.length + (curXhr.value ? 1 : 0) < filesLimit;
  })
 

  if (uploadedFiles.value === undefined) {
    uploadedFiles.value = [];
  }

  if (props.uploaded) {
    uploadedFiles.value = props.uploaded
  }

  const toSizeText    = (size:number) => {
    if (size < 1024) {
      return size + 'Bytes';
    } else if (size < 1048576) {
      return sizeFormater.format(Math.floor(size / 1024)) + 'KB';
    // } else if (size < 1073741824) {
    //   return sizeFormater.format(size / 1048576) + 'MB';
    } else {
      return sizeFormater.format(size / 1048576) + 'MB';
      // return sizeFormater.format(size / 1073741824) + 'GB';
    }
  }

  const checkUploadtoken  = (ev: Event) => {
    if (!uploadToken.value) {
      fetchUploadToken.execute().then(token => {
        uploadToken.value = token;
        if (uploadToken.value.filesLimit > storedFiles.value.length) {
          nextTick(() => {
            if (inputFile.value) {
              inputFile.value.click();
            }
          })
        }
       });
      ev.preventDefault();
    } else if (uploadToken.value.filesLimit <= storedFiles.value.length) {
      ev.preventDefault();
    }
  }

  const selectFile    = async (files?: FileList | null) => {
    if (files) {
      if (uploadToken.value === undefined) {
        uploadToken.value = await fetchUploadToken.execute();
      }

      for (let i = 0; i < files.length; i++) {
        let isAccept  = false;
        const fileName  = files[i].name.toLowerCase();
        const fileType  = files[i].type.toLowerCase();
        for (const acceptType of uploadToken.value.acceptTypes.map(t => t.toLowerCase()) ) {
          if (fileName.endsWith(acceptType)) {
            isAccept  = true;
            break;
          } else if (fileType.match(new RegExp('^' + acceptType.replaceAll('*', '.+')  + '$', 'i')) !== null) {
            isAccept  = true;            
            break;
          }
        }

        if (!isAccept) {
          showAlert({
            title: '알림',
            message: HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9147, files[i].name),
            confirmText: '확인'
          })
            if (inputFile.value) {
              inputFile.value.value  = '';
            }
            return;         
        }
      }

      if (props.selectValidator) {
        const denyMessage = props.selectValidator(Array.from(files));
        if (denyMessage) {
          showAlert({
            title: '알림',
            message: denyMessage,
            confirmText: '확인'
          })
          if (inputFile.value) {
            inputFile.value.value  = '';
          }
          return;         
        }
      }
    
      const newSelected:File[]  = [];
      const toBigFiles:File[]   = [];
      for (let i=0; i<files.length; i++) {
        if (files[i].size > uploadToken.value.sizeLimitPerFile) {
          toBigFiles.push(files[i]);
        } else {
          const newFileName  = files[i].name;
          const newFileSize  = files[i].size;
          const asUploaded   = uploadedFiles.value.find(uploadedFile => uploadedFile.name == newFileName && uploadedFile.size == newFileSize);
          if (asUploaded !== undefined) {
            if (asUploaded.status == 'MARKDELETE' && asUploaded.store == 'TEMPORARY') {
              asUploaded.status = 'STORED';
            } else {
              newSelected.push(files[i]);
            }
          } else {
            newSelected.push(files[i]);
          }
        }
      }

      if (storedFiles.value.length + newSelected.length > uploadToken.value.filesLimit) {
        showAlert({
          title: '알림',
          message: HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9148, `${uploadToken.value?.filesLimit}`),
          confirmText: '확인'
        })
        return;
      }

      const doSelectAfter = () => {
        if (newSelected.length) {
          nextTick(() => upload(newSelected));
        }
      }
      if (toBigFiles.length == 0) {
        doSelectAfter();
      } else {
        const errmsg    = `다음 파일들은 허용된 크기보다 크므로 선택에서 제외되었습니다.\n허용크기 ${toSizeText(uploadToken.value.sizeLimitPerFile)}\n` + toBigFiles.reduce((msg, file) => msg + `- ${file.name} : 파일 크기 ${toSizeText(file.size)}\n`, '');
        showAlert({
            title: '알림',
            message: errmsg,
            confirmText: '확인',
            onConfirm: () => doSelectAfter()
        })
      }
    }
  }

  const upload        = (selectedFiles:File[]) => {
    if (selectedFiles.length == 0) {
      showAlert({
        title: '알림',
        message: HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9150),
        confirmText: '확인'
      })
      return false;
    }
    if (uploadToken.value === undefined) {
      fetchUploadToken.execute().then(res => {
        uploadToken.value = res;
        upload(selectedFiles);
      });
      return true;
    }
    let authInfo        = useHconAuthInfo().getIfPossible();
    const uploadFileInfos:UploadFileInfo[]  = selectedFiles.map(file => ({name:file.name, type:file.type, size:file.size} as UploadFileInfo));
    const baseUrl       = config.api.baseUrl;
    const uploadSummary = new TextEncoder().encode(JSON.stringify(uploadFileInfos));
    const body          = new Blob([uploadSummary, Uint8Array.of(0, 0, 0), ...selectedFiles]);
    let   indexacu      = uploadSummary.length;
    const uploadIndexes = [indexacu];
    uploadFileInfos.map(info => {
      indexacu  += info.size;
      uploadIndexes.push(indexacu);
    });

    progress.value  = {
      status: '0%',
      bytes: {
        total: indexacu,
        current: 0,
      },
      total: {
        size: toSizeText(indexacu),
        cur: toSizeText(0),
        per: perFormater.format(0),
      },
      files: uploadFileInfos.map(info => ({
        size: toSizeText(info.size),
        cur: toSizeText(0),
        per: perFormater.format(0),
      }))
    }

    const refreshAndRetry = () => {
      if (authInfo) {
        // 토큰 만료시 whoami 호출하여 토큰 갱신 유도 후 재시도
        fetchWhoami.execute().then(res => {
          authInfo  = useHconAuthInfo().getIfPossible();
          if (authInfo) {
            xhr.setRequestHeader('Authorization', `Bearer ${authInfo.accessToken}`);
            xhr.send(body);
            authInfo = null; // 반복 재호출 방지
          }
        });
        return true;
      }
      return false;
    }

    const uploadComplete = (newUploaded:CommonFile[]) => {
      const errfiles  = newUploaded.filter(uploadedFiles => uploadedFiles.status != 'STORED');
      progress.value  = undefined;
      if (errfiles.length > 0) {
        if (errfiles.length != uploadedFiles.length) {
          showAlert({
            title: '알림',
            message: HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9151
                                                      , errfiles.reduce((msg, file) => msg + `- ${file.name} : ${file.statusDetail}\n`, '')),
            confirmText: '확인'
          })
        } else {
          showAlert({
            title: '알림',
            message: HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9152
                                                      , errfiles.reduce((msg, file) => msg + `- ${file.name} : ${file.statusDetail}\n`, '')),
            confirmText: '확인'
          })
        }
      }
      uploadedFiles.value = [...uploadedFiles.value, ...newUploaded];
      if (inputFile.value) {
        inputFile.value.value = '';
      }
      emits('change', uploadedFiles.value);
    }

    const xhr     = new XMLHttpRequest();
    curXhr.value  = xhr;
    xhr.upload.addEventListener('progress', (ev:ProgressEvent) => {
      if (progress.value) {
        progress.value.bytes.current    = ev.loaded;
        progress.value.total.cur        = toSizeText(ev.loaded);
        progress.value.total.per        = perFormater.format(ev.loaded / indexacu);
        if (progress.value.total.per == '100%') {
          progress.value.status         = '등록중...';
        } else {
          progress.value.status         = progress.value.total.per;
        }
        for (let i=1; i<uploadIndexes.length; i++) {
          if (ev.loaded < uploadIndexes[i-1]) {
            continue;
          } else if (ev.loaded > uploadIndexes[i-1] && ev.loaded < uploadIndexes[i]) {
            const cur   = ev.loaded - uploadIndexes[i-1];
            progress.value.files[i-1].cur = toSizeText(cur);
            progress.value.files[i-1].per = perFormater.format(cur / uploadFileInfos[i-1].size);
          } else if (ev.loaded >= uploadIndexes[i]) {
            progress.value.files[i-1].cur = toSizeText(uploadFileInfos[i-1].size);
            progress.value.files[i-1].per = perFormater.format(1);
          }
        }
      }
    })

    xhr.onreadystatechange = (ev: Event) => {
      if (xhr.readyState == XMLHttpRequest.DONE) {
        curXhr.value  = null;
        if (xhr.status == 200) {
          try {
            const result  = JSON.parse(xhr.response);
            if (result.resultCode !== undefined) {
              if (result.resultCode == '200') {
                uploadComplete(result.data);
                return;
              } else if (result.resultCode == '401') {
                if (refreshAndRetry()) {
                  return;
                }
                showAlert({
                  title: '알림',
                  message: HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9153),
                  confirmText: '확인'
                })
              } else if (result.resultCode == '403') {
                showAlert({
                  title: '알림',
                  message: HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9154),
                  confirmText: '확인'
                })
              } else {
                showAlert({
                  title: '알림',
                  message: HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9155, `${result.resultMessage}`),
                  confirmText: '확인'
                })
                abort(true);
              }
              return;
            }
            showAlert({
              title: '알림',
              message: HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9156),
              confirmText: '확인'
            })
          } finally {
            uploadToken.value = undefined;
          }
        }
      }
    };
    xhr.onerror = (ev: Event) => {
      if (xhr.status == 401) {
        if (refreshAndRetry()) {
          return;
        }
        showAlert({
          title: '알림',
          message: HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9153),
          confirmText: '확인'
        })
      } else {
        showAlert({
          title: '알림',
          message: HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9157),
          confirmText: '확인'
        })
      }
    }
    // xhr.open('POST', `${baseUrl}/customer/api/v1/common/files/${uploadToken.value.id}`, true);
    xhr.open('POST', `${baseUrl}/api/v1/common/files/${uploadToken.value.id}`, true);
    xhr.setRequestHeader('Content-Type', 'application/otect-stream');
    if (authInfo) {
      xhr.setRequestHeader('Authorization', `Bearer ${authInfo.accessToken}`);
    }
    xhr.send(body);
    return true;
  }

  // const reset = () => {
  //   if (curXhr != null) {
  //     dialog.alert('업로드 처리중이므로 다시선택 할 수 없습니다.');
  //     return false;
  //   }
  //   progress.value          = undefined;
  //   if (inputFile.value) {
  //     inputFile.value.value = '';
  //   }
  //   return true;
  // }

  const abort = (preventMessage?:boolean) => {
    if (curXhr.value != null) {
      curXhr.value.abort();
      curXhr.value  = null;
    } else if (!preventMessage) {
      showAlert({
        title: '알림',
        message: HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9158),
        confirmText: '확인'
      })
      return false;
    }
    progress.value    = undefined;
    if (inputFile.value) {
      inputFile.value.value   = '';
    }
    return true;
  }

  const removeFile = (fileId:string) => {
    const tfile = uploadedFiles.value.find(uploadedFile => uploadedFile.id == fileId);
    if (tfile) {
      if (tfile.store === 'TEMPORARY') {
        uploadedFiles.value = uploadedFiles.value.filter(uploadedFile => uploadedFile.id != fileId);
      } else {
        tfile.status = 'MARKDELETE';
        // 추가 : 화면에서도 제거
        uploadedFiles.value = uploadedFiles.value.filter(uploadedFile => uploadedFile.id != fileId);
      }
      isAddNewable.value  = true;
      emits('change', uploadedFiles.value);
    }
  }

  const dragoverFile  = (e:DragEvent) => {
    if (e.dataTransfer && e.dataTransfer.files && !isDisabled.value) {
      e.dataTransfer.effectAllowed    = 'copyMove';
      e.dataTransfer.dropEffect       = 'copy';
      areaBorder.value                = "solid 2px blue";
    } else {
      if (e.dataTransfer) {
        e.dataTransfer.effectAllowed    = 'none';
        e.dataTransfer.dropEffect       = 'none';
      }
    }
    e.preventDefault();
  }

  const dragleaveFile = (e:DragEvent) => {
    areaBorder.value  = undefined;
  }

  const dropFile  = (e:DragEvent) => {
    areaBorder.value  = undefined;
    if (e.dataTransfer && e.dataTransfer.files) {
      selectFile(e.dataTransfer.files);
    }

    e.preventDefault();
  }  

  onBeforeUnmount(() => abort(true));
  watch(progress, (newValue, oldValue) => {
    if (newValue && oldValue === undefined) {
      emits('busy', true);
    } else if (newValue === undefined && oldValue) {
      emits('busy', false);
    }
  })
</script>

<style lang="scss" scoped>
@use "@/assets/scss/pc/cs-hcon.scss" as *;
.upload-area {
  width: 100%;
  box-sizing: border-box;
}

.upload-progress-area {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
  background-color: rgba(255, 255, 255, 0.5);
  display:flex;
  flex-direction:column;
  justify-content:center;
}
</style>